import React from 'react'
import { useParams } from 'react-router-dom'
import { apiGenerator } from '../../../../util/functions'
import CONSTANTS from '../../../../util/constant/CONSTANTS'
import { Card, Row } from 'antd'
import Heading from '../../../../component/common/Heading'
import CRUDComponent from '../../../../component/common/CRUD-Component'
import moment from 'moment'

const Subscription = () => {
    const { id } = useParams()

    // console.log(id);

    const userSubscriptionApi = apiGenerator(CONSTANTS.API.Subscription.getAll, {}, `?userId=${id}`)
    return (
        <>
            <div>
                <Card>
                    <Heading>Subscription</Heading>

                    <Row>
                        <CRUDComponent
                            GET={{
                                API: userSubscriptionApi,
                                DataModifier: (res, API, Setrefresh) => {
                                    // console.log(res, "GET ALL ABCD");
                                    return res?.map(data => {
                                        return {
                                            ...data,
                                            no: `S${data?.id.toString().padStart(7, "0")}`,
                                            expiryDate: moment(data?.expiryDate).format('DD MMM YYYY'),
                                            name: data?.subPlan?.name,
                                            petName: data?.pet?.name,


                                        }
                                    })
                                },
                                column: CONSTANTS.TABLE.USER_SUBSCRIPTION,
                            }}
                            isSearch={true}

                        />
                    </Row>
                </Card>
            </div>

        </>
    )
}

export default Subscription